export default class CategoryModel {
  id = 0

  name = ''
}
